import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppClaims } from '@app/cp/shared/models/AppClaims';
import { environment } from '@env/environment';
import { DomainDialogComponent } from "@app/cp/shared/components/domain-dialog/domain-dialog.component";
import { BillingCodesDialogComponent } from "@app/cp/shared/domain-data/billing-codes-dialog/billing-codes-dialog.component";
import { PartTypeDialogComponent } from "@app/cp/shared/domain-data/part-type-dialog/part-type-dialog.component";
import { PartCategoryDialogComponent } from "@app/cp/shared/domain-data/part-category-dialog/part-category-dialog.component";
import { PartSubcategoryDialogComponent } from "@app/cp/shared/domain-data/part-subcategory-dialog/part-subcategory-dialog.component";
import { ConfirmOutput } from "@app/cp/shared/models/ConfirmOutput";
import { CPDialogResult } from "@app/cp/shared/enums/CPDialogResult";
import { UserCreditMemoComponent } from '@app/cp/shared/components/user-credit-memo/user-credit-memo.component';
import { ManufacturerTypeDialogComponent } from '@app/cp/shared/domain-data/manufacturer-type-dialog/manufacturer-type-dialog.component';
import { CmProAuthService } from '@app/core/services';
import { UsersBus } from '@app/cp/shared/models/UsersBus.model';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
import { ReportCategory, REPORTS } from "@app/cp/shared/static/reports.config";

@UseFeatureFlagSet()
@Component({
    selector: 'sa-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent  implements OnInit, OnDestroy {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    active: boolean = false;
    depEnv: string;
    toggleUserCreditMemo: boolean = false;
    reports: ReportCategory[] = REPORTS;
    protected isZuggit: boolean = false;

    reportsDeprecated: Array<any> = []; //! Deprecated

    public logoSource: string = 'assets/img/logo.png';

    @ViewChild('domainDialog') public domainDialog: DomainDialogComponent;
    @ViewChild('billingCodesDialog') public billingCodesDialog: BillingCodesDialogComponent;
    @ViewChild('userCreditMemo') public userCreditMemo: UserCreditMemoComponent;
    @ViewChild('partTypeDialog') public partTypeDialog: PartTypeDialogComponent;
    @ViewChild('manufacturerTypeDialog') public manufacturerTypeDialog: ManufacturerTypeDialogComponent;
    @ViewChild('partCategoryDialog') public partCategoryDialog: PartCategoryDialogComponent;
    @ViewChild('partSubcategoryDialog') public partSubcategoryDialog: PartSubcategoryDialogComponent;

    constructor(private globals: GlobalsService, private authService: CmProAuthService) {
        this.depEnv = environment.deployment;
    }

    rights: AppClaims = new AppClaims();

    setExpenseURL(url: string) {
        let expenseURL: string;
        if (url == 'submit') {
            expenseURL = environment.AppUrlExpenseMaint + '?redirect=emSubmit';
        } else {
            expenseURL = environment.AppUrlExpenseMaint + '?redirect=emMaint';
        }
        window.open(expenseURL, "_blank");
    }

    customDownloadActive: boolean = false;

    customDownloadClosed(e: any) {
        this.customDownloadActive = false;
    }

    customUploadActive: boolean = false;

    customUploadClosed(e: any) {
        this.customUploadActive = false;
    }

    get isDev() {
        return this.depEnv === 'dev' || this.depEnv === 'local';
    }

    ngOnDestroy(): void {
        this.authService.unsubscribeToLoginEvents();
    }

    ngOnInit() {
        this.depEnv = environment.deployment;

        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
                this.setLogoInNav();

                if (!this.compFeatureFlagSet.featureFlagSet['ui-new-reports-structure']){
                    this.initReportsArray();
                }
            }
        });
    }

    close() {
        this.active = false;
        this.customUploadActive = false;
        this.customDownloadActive = false;
    }


    showPopup(id: number) {
        this.domainDialog.show(id);
    }

    refreshRefferenceData(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok) {
            //this.refreshRefference();
        }
    }

    goTo(reportURL) {
        window.open(reportURL, '_blank');
    }

    initReportsArray() {
        this.reportsDeprecated = [
            {
                "category": "Dashboards",
                "icon": 'fa-tachometer',
                "categoryRights": true,
                "data": [
                    {
                        "report": "Branch Manager",
                        "rights": true && !this.isZuggit,
                        "link": "https://app.powerbi.com/Redirect?action=OpenApp&appId=e0f89834-9ffa-4b69-abe2-4410924b2af4&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"

                    },
                    {
                        "report": "Service Manager",
                        "rights": true && !this.isZuggit,
                        "link": "https://app.powerbi.com/Redirect?action=OpenApp&appId=21add3d2-a7d2-4ab4-abb2-d52396a2314e&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "RVP",
                        "rights": true && !this.isZuggit,
                        "link": "https://app.powerbi.com/Redirect?action=OpenApp&appId=5e90b650-0683-43fe-945f-d6d38fffcfa9&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Construction",
                        "rights": true && !this.isZuggit,
                        "link": "https://app.powerbi.com/Redirect?action=OpenApp&appId=ca367773-da5e-4e21-8cab-b9e67324d9b1&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Purchasing",
                        "rights": this.rights.purchaseDashboardReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/Redirect?action=OpenApp&appId=c1c61c84-eb69-406f-bc0d-682281b427ef&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&experience=power-bi"
                    },
                    {
                        "report": "Warehouse",
                        "rights": this.rights.warehouseDashboardReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/Redirect?action=OpenApp&appId=3e48a307-b538-431e-8087-70e1c94aee74&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&experience=power-bi"
                    },
                    {
                        "report": "Zuggit Purchasing",
                        "rights": this.rights.zuggitPurchasingDashboardReport && this.isZuggit,
                        "link": "https://app.powerbi.com/Redirect?action=OpenApp&appId=5f959b3d-9d38-4813-9fb6-c54eb24eaf45&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&experience=power-bi"
                    }

                ],
            },
            {
                "category": "Invoice",
                "icon": 'fa-dollar-sign',
                "categoryRights": this.rights.InvoiceSalesReport ||
                    this.rights.InvoiceSalesSummary ||
                    this.rights.ARReport ||
                    this.rights.CustomerSalesSummaryReport ||
                    this.rights.CustomerPaymentReport ||
                    this.rights.InvoiceCreatedReport ||
                    this.rights.TaxReport ||
                    this.rights.zuggitInvoiceSales2Report ||
                    this.rights.zuggitARNotesReport ||
                    this.rights.zuggitCustomerPaymentReport,
                "data": [
                    {
                        "report": "Invoice Sales",
                        "rights": this.rights.InvoiceSalesReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=ba38476e-063f-485a-ba41-c143e5b95553&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Invoice Sales 2",
                        "rights": this.rights.InvoiceSalesSummary && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=7ab5761e-0191-4464-88a2-8d6ec1a0450d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
                    },
                    {
                        "report": "AR with Notes",
                        "rights": this.rights.ARReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=305536fa-1747-4383-aefb-607af03eca97&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Customer Sales",
                        "rights": this.rights.CustomerSalesSummaryReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=fa31acee-36b8-4e1b-b0bd-c00bf8dae6b8&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Customer Payment",
                        "rights": this.rights.CustomerPaymentReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=a7a4f8c6-b23a-403d-927d-b679a3d89b7b&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Invoice Created",
                        "rights": this.rights.InvoiceCreatedReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=3dea5d63-c2f2-48a3-b27a-43cbfb10c1af&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Tax",
                        "rights": this.rights.TaxReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=ec852269-fdb5-4c56-b0c8-68f8e9140a1d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Active Dispute Widget",
                        "rights": this.rights.TaxReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=992c5cb6-18ef-42d8-80a2-247df9e9985d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Profitability Grouping",
                        "rights": this.rights.InvoiceProfitabilityGroupingReport  && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=4ed9064a-7632-4c60-9022-3a33cf6ea3c9&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Invoice Status History",
                        "rights": this.rights.InvoiceStatusHistoryReport  && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=08745072-16fc-4964-9e34-8cbb2e1d001e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Invoice Sales 2",
                        "rights": this.rights.zuggitInvoiceSales2Report  && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=5f7182d9-714d-47f1-832d-8b258d62cb15&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit AR with Notes",
                        "rights": this.rights.zuggitARNotesReport  && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=fa2c36fd-682d-4173-b243-c322186aa393&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Customer Payment",
                        "rights": this.rights.zuggitCustomerPaymentReport  && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=1f3ea229-56ac-445c-b481-d7d2d3283e7f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    }
                ],
            },
            {
                "category": "Dispatch",
                "icon": 'fa-phone',
                "categoryRights": this.rights.OpenDispatchTicketReport ||
                    this.rights.TechHoursReport ||
                    this.rights.DispatchEquipmentHistory ||
                    this.rights.DispacthStatusHistoryReport ||
                    this.rights.DispatchCreatedReport ||
                    this.rights.WrongPartsRequested ||
                    this.rights.EmpCensusReport ||
                    this.rights.DispatchLaborReport ||
                    this.rights.WeeklyServiceLaborReport ||
                    this.rights.WeeklyServiceLaborReport ||
                    this.rights.zuggitDispatchSummaryReport ||
                    this.rights.zuggitEquipmentHistoryReport ||
                    this.rights.zuggitWrongPartsRequestedReport,
                "data": [
                    {
                        "report": "Dispatch & Open Dispatch Summary",
                        "rights": this.rights.OpenDispatchTicketReport  && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=14e665fa-6202-4999-b06d-8c8336a20c7d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Tech Hours",
                        "rights": this.rights.TechHoursReport  && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=882c28ef-68e8-48c6-9f64-2b80ef75bc9e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Equipment History",
                        "rights": this.rights.DispatchEquipmentHistory  && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=8daae54a-6729-4e16-9374-569eef1efb9e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Status History",
                        "rights": this.rights.DispacthStatusHistoryReport  && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=d6973eae-8621-4475-a5f9-2b60fefbdd10&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
                    },
                    {
                        "report": "Created",
                        "rights": this.rights.DispatchCreatedReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=28f7e625-888a-4127-866c-b72edb8edc26&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Wrong Parts Requested",
                        "rights": this.rights.WrongPartsRequested && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=def53277-15aa-4ee9-8d2c-be7b2209f941&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Employee Census",
                        "rights": this.rights.EmpCensusReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=74dd4755-a3f6-447a-aa8c-dd9b480291fd&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Labor",
                        "rights": this.rights.DispatchLaborReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=44c23f37-ac1c-4e07-a219-0cbc74fb6905&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Trips to Complete",
                        "rights": this.rights.WeeklyServiceLaborReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=78e504dd-f7dc-4b35-ae25-483cdcaf1fa0&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Weekly Service Labor Report",
                        "rights": this.rights.WeeklyServiceLaborReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=1be86819-c106-468d-9243-e62a372f685d&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Zuggit Dispatch & Open Dispatch Summary",
                        "rights": this.rights.zuggitDispatchSummaryReport  && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=483c728a-2931-4d3e-bda2-76b0c99a9c72&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Equipment History",
                        "rights": this.rights.zuggitEquipmentHistoryReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=9d87e31b-d497-4f96-ba8b-c39e656ebd5f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Wrong Parts Requested",
                        "rights": this.rights.zuggitWrongPartsRequestedReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=f7d80691-a84b-445e-8ce3-754c9ad740bd&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    }
                ],
            },
            {
                "category": "Construction",
                "icon": 'fa-toolbox',
                "categoryRights": this.rights.DispatchPMBoardConfirmations || this.rights.PostConstructionWarrantyReport,
                "data": [
                    {
                        "report": "Dispatch PM Board Confirmations",
                        "rights": this.rights.DispatchPMBoardConfirmations && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=b9defc36-377d-422e-baa5-d4d6453d0f27&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Post Construction Warranty Monthly Job",
                        "rights": this.rights.PostConstructionWarrantyReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=50a886ef-d463-4b9a-9d27-7c460c5c2b7f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    }
                ],
            },
            {
                "category": "Quote",
                "icon": 'fa-quote-right',
                "categoryRights": this.rights.QuoteSummary || this.rights.zuggitQuoteSummaryReport,
                "data": [
                    {
                        "report": "Quote Summary",
                        "rights": this.rights.QuoteSummary && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=b60c02f0-b8c9-44dc-a33a-b4255f96b304&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
                    },
                    {
                        "report": "Zuggit Quote Summary",
                        "rights": this.rights.zuggitQuoteSummaryReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=3795691c-d947-4cd5-aef1-4e33b0f4d10e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                ],
            },
            {
                "category": "Order",
                "icon": 'fa-receipt',
                "categoryRights": this.rights.POReport || this.rights.zuggitPurchaseOrderReport || this.rights.zuggitPurchaseOrderBillReport ||this.rights.zuggitWrongPartsOrderedReport,
                "data": [
                    {
                        "report": "Purchase Order",
                        "rights": this.rights.POReport  && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=b87551e5-107e-4ae6-8d16-40e5f0bc84eb&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Purchase Order Bill",
                        "rights": this.rights.POReport  && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=aae1892b-8614-4600-b61e-6180fcddc06a&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Wrong Parts Ordered",
                        "rights": this.rights.POReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=700589f0-82e2-44ce-80d7-a3198ed8a2ba&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Zuggit Purchase Order",
                        "rights": this.rights.zuggitPurchaseOrderReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=4b95164a-ef65-4793-a8b5-f196a97cef51&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Purchase Order Bill",
                        "rights": this.rights.zuggitPurchaseOrderBillReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=39d0f41c-7fcd-456b-ae10-ef6d27a46b17&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Wrong Parts Ordered",
                        "rights": this.rights.zuggitWrongPartsOrderedReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=31e201af-c4df-4892-9c28-8b63ce3f3060&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                ],
            },
            {
                "category": "Parts",
                "icon": 'fa-box',
                "categoryRights": this.rights.InventoryQuantityCostReport ||
                    this.rights.ARReport || this.rights.CommonInventory ||
                    this.rights.PartBoughtSoldReport ||
                    this.rights.AssetHistoryReport ||
                    this.rights.InventoryThresholdsReport ||
                    this.rights.zuggitInventoryQuantityCostReport||
                    this.rights.zuggitPartsActivityReport||
                    this.rights.zuggitPartBoughtSoldReport||
                    this.rights.zuggitSupplierQueryReport ||
                    this.rights.zuggitDailyReceivedByReport,
                "data": [
                    {
                        "report": "Inventory Quantity Cost",
                        "rights": this.rights.InventoryQuantityCostReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=934baadb-aee2-4919-a582-3e2d74fbcb0e&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Inventory",
                        "rights": this.rights.ARReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=558e7a74-828d-4a6b-bfdf-334e68add7b1&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Common Inventory",
                        "rights": this.rights.CommonInventory && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=85e1a2bf-e19a-4ab7-aa4e-0ed5d0d1cbfc&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Part Cycle Count",
                        "rights": this.rights.ARReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=5f87b4b1-1767-457b-a596-b8ca838ad0f7&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Part Bought/Sold",
                        "rights": this.rights.PartBoughtSoldReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=f54b2b1d-e7da-4b63-8ab0-a99b0b9f6a4c&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Part Activity",
                        "rights": this.rights.ARReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=65ea8304-afd2-4bfa-b697-3eaa4bf7f1f8&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Part Activity Unused Only",
                        "rights": this.rights.ARReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=5f0029dc-9e50-4ac9-9474-06c68e1cd346&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Asset History",
                        "rights": this.rights.AssetHistoryReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=eeea9a02-5470-4f35-b7d3-adec5c8514f6&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Inventory Thresholds",
                        "rights": this.rights.InventoryThresholdsReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=ad832bff-11cb-4a6f-877a-6423afda02f5&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
                    },
                    {
                        "report": "Commit History",
                        "rights": this.rights.CommonInventory && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=a74f480f-b706-4e6b-b074-a9a2ac7b079f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Inventory Quantity Cost",
                        "rights": this.rights.zuggitInventoryQuantityCostReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=b4cd9f1b-f79e-43f9-9a68-e6bb2e2c0898&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Part Activity",
                        "rights": this.rights.zuggitPartsActivityReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=1b9df873-ff4f-4c7b-a8d1-07bc0feea79b&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Part Bought/Sold",
                        "rights": this.rights.zuggitPartBoughtSoldReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=1cc96308-65ed-413c-b568-e8f5870de4aa&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Supplier Query",
                        "rights": this.rights.zuggitSupplierQueryReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=deed256f-89f1-4f03-9d04-4bcfc54d4710&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Zuggit Daily Received By",
                        "rights": this.rights.zuggitDailyReceivedByReport && this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=baaaa039-77d6-4f5e-850d-bb385afcbe47&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                ],
            },
            {
                "category": "Customer",
                "icon": 'fa-building',
                "categoryRights": this.rights.InventoryThresholdsReport,
                "data": [
                    {
                        "report": "Customer Details",
                        "rights": this.rights.InventoryThresholdsReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=d077e353-f621-463c-a533-e1d2ff00b458&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
                    },
                ],
            },
            {
                "category": "Employee",
                "icon": 'fa-users',
                "categoryRights": this.rights.EmpBreakdownReport || this.rights.LaborLineUnionReport || this.rights.EmployeeErrorsReport,
                "data": [
                    {
                        "report": "Employee Breakdown",
                        "rights": this.rights.EmpBreakdownReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=03336475-6512-429f-9fab-efc0b604560f&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    },
                    {
                        "report": "Employee Opportunities",
                        "rights": this.rights.EmployeeErrorsReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=b8d22675-4aff-494e-ab03-9ff9601ba008&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtaC1wcmltYXJ5LXJlZGlyZWN0LmFuYWx5c2lzLndpbmRvd3MubmV0LyJ9"
                    },
                    {
                        "report": "Employee Kudos",
                        "rights": this.rights.EmployeeErrorsReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=f2cd817b-d1cc-44b2-8a6c-5a7192a5fcf6&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974"
                    },
                    {
                        "report": "Labor Line/Union",
                        "rights": this.rights.LaborLineUnionReport && !this.isZuggit,
                        "link": "https://app.powerbi.com/reportEmbed?reportId=2e79c80f-abff-44d3-bcb0-c6b16e20b6a9&autoAuth=true&ctid=522b35a5-68e2-4f5a-81dd-6ce68592d974&config=eyJjbHVzdGVyVXJsIjoiaHR0cHM6Ly93YWJpLXVzLW5vcnRoLWNlbnRyYWwtcmVkaXJlY3QuYW5hbHlzaXMud2luZG93cy5uZXQvIn0%3D"
                    }
                ]
            }
        ];
    }

    openTimeOffCalendar() {
        window.open("https://www.fieldgetics.com/EmployeeTime/index.html?personId=" + this.globals.personId);
    }

    toggleUserCreditMemoDisplay() {
        this.toggleUserCreditMemo = !this.toggleUserCreditMemo;
    }

    private setLogoInNav() {
        const isZuggitUser: boolean = this.globals.user.isZuggitUser;
        //Sets reports view for CP vs Zuggit
        this.isZuggit = isZuggitUser;
        //Sets Zuggit loader in header
        this.logoSource = !isZuggitUser ? 'assets/img/logo.png' : 'assets/img/zuggitFJ_logo_white.png';
    }
}

